export const SESSION_EXPIRED_EVENT = 'agentous:session-expired';
export const SESSION_EXPIRED_MESSAGE =
  'Your session has expired. Please log in again.';

export interface SessionExpiredDetail {
  reason?: string;
  source?: string;
}
